import { KiaAssistantError, type ElementRef } from '../types';

/**
 * Resolves a configured element reference (CSS selector or direct
 * HTMLElement) and validates it exists and is actually part of the DOM.
 * Throws KiaAssistantError with a stable `code` so callers can distinguish
 * which of the three required elements is missing.
 */
export function resolveElement(
  ref: ElementRef | undefined,
  code: string,
  label: string,
): HTMLElement {
  if (ref === undefined || ref === null || ref === '') {
    throw new KiaAssistantError(`Missing required "${label}" element in config.`, code);
  }

  if (typeof ref === 'string') {
    const found = document.querySelector(ref);
    if (!(found instanceof HTMLElement)) {
      throw new KiaAssistantError(
        `Could not resolve "${label}" element for selector "${ref}".`,
        code,
      );
    }
    return found;
  }

  if (!(ref instanceof HTMLElement)) {
    throw new KiaAssistantError(
      `"${label}" must be a CSS selector string or an HTMLElement.`,
      code,
    );
  }

  if (!document.contains(ref)) {
    throw new KiaAssistantError(`"${label}" element is not attached to the document.`, code);
  }

  return ref;
}
